import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudService, RxjsService } from '@app/shared/services';
import { IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, setRequiredValidator } from '@app/shared/utils';
import { loggedInUserData } from '@modules/others';
import { LeadNotesModel } from '@modules/sales/models/lead-notes';
import { Store } from '@ngrx/store';
import { SalesModuleApiSuffixModels } from '@sales/shared';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
@Component({
  selector: 'lead-notes-modal-component',
  templateUrl: './lead-notes-modal.component.html',
  styleUrls: ['./lead-notes.scss'],
})
export class LeadNoteModalComponent implements OnInit {
  leadId = "";
  leadNoteForm: FormGroup;
  loggedInUserData: LoggedInUserModel;
  fileList: File[] = [];
  buttonDisable = false;
  @ViewChild('fileInput', null) myFileInputField: ElementRef;
  data;

  constructor(private formBuilder: FormBuilder, public ref: DynamicDialogRef, public config: DynamicDialogConfig,
    private activatedRoute: ActivatedRoute,
    private rxjsService: RxjsService,
    private crudService: CrudService, private store: Store<AppState>) {
    this.data = config?.data;
  }

  ngOnInit() {
    this.rxjsService.setDialogOpenProperty(true);
    this.combineLatestNgrxStoreData();
    this.createLeadNoteForm();
  }

  combineLatestNgrxStoreData(): void {
    combineLatest([this.store.select(loggedInUserData), this.activatedRoute.queryParams]
    ).pipe(take(1)).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      this.leadId = response[1]?.leadId;
    });
  }

  createLeadNoteForm(): void {
    let emailNotificationModel = new LeadNotesModel();
    this.leadNoteForm = this.formBuilder.group({
    });
    Object.keys(emailNotificationModel).forEach((key) => {
      this.leadNoteForm.addControl(key, new FormControl(emailNotificationModel[key]));
    });
    this.leadNoteForm = setRequiredValidator(this.leadNoteForm, ["comments"]);
  }

  emitUploadedFiles(uploadedFiles: any[]) {
    this.fileList = uploadedFiles;
  }

  onSubmit(): void {
    if (this.leadNoteForm.invalid) {
      this.leadNoteForm.markAllAsTouched();
      return;
    }
    this.buttonDisable = true;
    var formValue = this.leadNoteForm.value;
    formValue.leadId = this.data?.leadId;
    formValue.createdUserId = this.loggedInUserData.userId;
    let formData = new FormData();
    formData.append('comment', JSON.stringify(formValue));
    this.fileList.forEach(file => {
      formData.append('file', file);
    });
    this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_LEAD_NOTES, formData)
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          this.rxjsService.setLeadNotesUpdateStatus(true);
          this.rxjsService.setDialogOpenProperty(false);
          this.ref.close(true);
          this.buttonDisable = false;
        }
      });
  }

  dialogClose(): void {
    this.ref.close(false);
  }

  ngOnDestroy() {
    this.rxjsService.setDialogOpenProperty(false);
  }
}
